import React from 'react';
import {notification} from 'antd';
import {ClockCircleOutlined} from '@ant-design/icons';

const PENDING_ICON_COLOR = '#f59e0b';

const NotificationService = {
  pending(message, description, duration = 5) {
    notification.open({
      message,
      description,
      duration,
      placement: 'top',
      icon: <ClockCircleOutlined style={{color: PENDING_ICON_COLOR}} />,
    });
  },

  success(message, description, duration = 5) {
    notification.success({
      message,
      description,
      duration,
      placement: 'top',
    });
  },

  error(message, description, duration = 5) {
    notification.error({
      message,
      description,
      duration,
      placement: 'top',
    });
  },

  info(message, description, duration = 5) {
    notification.info({
      message,
      description,
      duration,
      placement: 'top',
    });
  },

  warning(message, description, duration = 5) {
    notification.warning({
      message,
      description,
      duration,
      placement: 'top',
    });
  },
};

export default NotificationService;
